import { render, staticRenderFns } from "./ownGoodsLibrary copy.vue?vue&type=template&id=dd72d4d4&scoped=true&"
import script from "./ownGoodsLibrary copy.vue?vue&type=script&lang=js&"
export * from "./ownGoodsLibrary copy.vue?vue&type=script&lang=js&"
import style0 from "./ownGoodsLibrary copy.vue?vue&type=style&index=0&id=dd72d4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd72d4d4",
  null
  
)

component.options.__file = "ownGoodsLibrary copy.vue"
export default component.exports